export const featuredPortfolio = [
  {
    id: 1,
    title: "Customer-Relationship-Management-software",
    githubUrl: "https://github.com/anuragsharma1111994/profile-rest-api",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 2,
    title: "Virtual-Crypto-Currency-Application",
    githubUrl: "https://github.com/anuragsharma1111994/Virtual-Crypto-Currency-Application",
    img: "https://cdn.dribbble.com/users/702789/screenshots/15054318/media/4ea5d492b7b07eebc9528ff960794879.png?compress=1&resize=1200x900",
  },
  {
    id: 3,
    title: "Food recipes Application",
    githubUrl: "https://github.com/anuragsharma1111994/RN---Food-recipes-Android-And-IOS-Application",
    img: "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
  },
  {
    id: 4,
    title: "Video-Call-App",
    githubUrl: "https://github.com/anuragsharma1111994/Video-Call-App/projects",

    img: "https://cdn.dribbble.com/users/4095861/screenshots/15467417/media/d6a15c416626f12b31fa5ca1db192572.png?compress=1&resize=1200x900",
  },
  {
    id: 5,
    title: "Uber Ride Pridection",
    githubUrl:"https://github.com/anuragsharma1111994/uber_rides_pridection",
    img: "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
  },
  {
    id: 6,
    title: "Short-Video-Social-Media-Applicaton",
    githubUrl: "https://github.com/anuragsharma1111994/Short-Video-Social-Media-Applicaton",
    img: "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
  },
  {
    id: 7,
    title: "Others",
    githubUrl: "Upload On Github Soon",
    img: "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
  },
];

export const webPortfolio = [
  {
    id: 1,
    title: "Customer-Relationship-Management-software",
    githubUrl: "https://github.com/anuragsharma1111994/profile-rest-api",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 2,
    title: "File Sharing Web App",
    githubUrl: "https://github.com/anuragsharma1111994/VotiShare-Backend",
    img: "https://cdn.dribbble.com/users/702789/screenshots/15054318/media/4ea5d492b7b07eebc9528ff960794879.png?compress=1&resize=1200x900",
  },
  {
    id: 3,
    title: "Ecommerce-Backend",
    githubUrl: "https://github.com/anuragsharma1111994/MERN-Ecommerce-Backend",
    img: "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
  },
  {
    id: 4,
    title: "Video-Call-App",
    githubUrl: "https://github.com/anuragsharma1111994/Video-Call-App/projects",

    img: "https://cdn.dribbble.com/users/4095861/screenshots/15467417/media/d6a15c416626f12b31fa5ca1db192572.png?compress=1&resize=1200x900",
  },
  {
    id: 5,
    title: "Amazon Frontend Clone",
    githubUrl:"https://github.com/anuragsharma1111994/Amazon-Front-End-Build",
    img: "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
  },
  {
    id: 6,
    title: "Google-Search-Engine-Clone",
    githubUrl: "https://github.com/anuragsharma1111994/Google-Search-Engine-Clone",
    img: "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
  },
  {
    id: 7,
    title: "Facebook Clone",
    githubUrl: "https://github.com/anuragsharma1111994/FaceBook-Clone",
    img: "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
  },
  {
    id: 8,
    title: "Youtube Clone",
    githubUrl: "https://github.com/anuragsharma1111994/Youtube-Clone",
    img: "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
  },
  {
    id: 9,
    title: "Others",
    githubUrl: "Upload On Github Soon",
    img: "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
  },
];

export const mobilePortfolio = [
  {
    id: 1,
    title: "Short Video Sharing Platform ",
    githubUrl: "https://github.com/anuragsharma1111994/Short-Video-Social-Media-Applicaton",
    img: "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
  },
  {
    id: 2,
    title: "Food-recipes-Android-And-IOS-Application",
    githubUrl: "https://github.com/anuragsharma1111994/RN---Food-recipes-Android-And-IOS-Application",
    img: "https://cdn.dribbble.com/users/5920881/screenshots/15463142/media/b5a460223798bd85d835710806e2f3dd.png?compress=1&resize=1200x900",
  },
  {
    id: 3,
    title: "Virtual-Crypto-Currency-Application",
    githubUrl: "https://github.com/anuragsharma1111994/Virtual-Crypto-Currency-Application",
    img: "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
  },
  {
    id: 4,
    title: "Gym-Application",
    githubUrl: "https://github.com/anuragsharma1111994/RN---Gym-Application",
    img: "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
  },
  {
    id: 5,
    title: "Others",
    githubUrl: "Upload On Github Soon",
    img: "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
  },
  
];

export const dataSciencePortfolio = [
  {
    id: 1,
    title: "Breast-Cancer-Detection",
    githubUrl: "https://github.com/anuragsharma1111994/Breast-Cancer-Detection",
    img: "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
  },
  {
    id: 2,
    title: "Car Price Pridection",
    githubUrl: "https://github.com/anuragsharma1111994/Car-Price-Predection-",
    img: "https://cdn.dribbble.com/users/5920881/screenshots/15463142/media/b5a460223798bd85d835710806e2f3dd.png?compress=1&resize=1200x900",
  },
  {
    id: 3,
    title: "FIFA-21-Data-Analysis",
    githubUrl: "https://github.com/anuragsharma1111994/FIFA-21-Data-Analysis",
    img: "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
  },
  {
    id: 4,
    title: "TensorflowJS-FaceLand-Mark-Detection",
    githubUrl: "https://github.com/anuragsharma1111994/TensorflowJS---FaceLand-Mark-Detection",
    img: "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
  },
  {
    id: 5,
    title: "OpenCV-Volume-Control-Using-Hand-",
    githubUrl: "https://github.com/anuragsharma1111994/OpenCV---Volume-Control-Using-Hand-",
    img: "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
  },
  {
    id: 6,
    title: "Optical-Mark-Recognition",
    githubUrl: "https://github.com/anuragsharma1111994/Optical-Mark-Recognition",
    img: "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
  },
  {
    id: 7,
    title: "Others",
    githubUrl: "Upload On Github Soon",
    img: "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
  },
];

export const ComputerVisionPortfolio = [
  {
    id: 1,
    title: "Content Social Media App",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 2,
    title: "Content Rampa UI Design",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 3,
    title: "Content E-commerce Web Design",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 4,
    title: "Content Relax Mobile App",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 5,
    title: "Content Keser Web Design",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 6,
    title: "Content Banking App",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
];
export const OtherPortfolio = [
  {
    id: 1,
    title: "Content Social Media App",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 2,
    title: "Content Rampa UI Design",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 3,
    title: "Content E-commerce Web Design",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 4,
    title: "Content Relax Mobile App",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 5,
    title: "Content Keser Web Design",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 6,
    title: "Content Banking App",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
];
